import { SplitText } from 'gsap/SplitText';

export default class Split extends HTMLElement {
  constructor() {
    super();
    // UI

    // Config

    // Data
    this.target = this.querySelector('[data-split-text]')
      ? this.querySelector('[data-split-text]')
      : this.children[0];

    this.type = this.dataset?.type ? this.dataset.type : 'lines';
  }

  // =============================================================================
  // Lifecycle methods
  // =============================================================================
  connectedCallback() {
    return null;
    this.bindEvents();
  }

  disconnectedCallback() {
    return null;
    this.unbindEvents();
  }

  // =============================================================================
  // Events
  // =============================================================================
  bindEvents() {
    this.splitText = SplitText.create(this.target, {
      type: 'lines',
      // mask: 'lines',
      linesClass: 'c-split_line',
      wordsClass: 'c-split_word',
      charsClass: 'c-split_char',
      autoSplit: true,
      smartWrap: true,
      onSplit: self => {
        this.split(self);
      }
    });

    // Слушаем окончание transition (в стилях используется transition, не animation)
    // Склеиваем текст когда закончилась анимация последней строки
    this.handleTransitionEnd = event => {
      if (event.propertyName !== 'transform') return;
      if (!this.splitText?.lines?.length) return;
      const lastLine = this.splitText.lines[this.splitText.lines.length - 1];
      if (event.target === lastLine) {
        this.revert();
      }
    };

    this.splitText.lines.forEach(line => {
      line.addEventListener('transitionend', this.handleTransitionEnd);
    });
  }

  split(self) {
    this.style.setProperty('--lines-count', self.lines.length);
    this.style.setProperty('--words-count', self.words.length);
    this.style.setProperty('--chars-count', self.chars.length);

    self.lines.forEach((line, index) => {
      line.style.setProperty('--line-index', index);
    });
    self.words.forEach((word, index) => {
      word.style.setProperty('--word-index', index);
    });
    self.chars.forEach((char, index) => {
      char.style.setProperty('--char-index', index);
    });
  }

  unbindEvents() {
    if (this.handleTransitionEnd && this.splitText?.lines) {
      this.splitText.lines.forEach(line => {
        line.removeEventListener('transitionend', this.handleTransitionEnd);
      });
    }

    // При размонтировании (переход на другую страницу) не вызываем revert() —
    // он меняет DOM в момент замены контента Swup и текст пропадает.
    // Только очищаем инстанс через kill().
    if (this.splitText) {
      this.splitText.kill?.();
      this.splitText = null;
    }
  }

  ///////////////
  // Methods
  ///////////////

  // Склеивает текст обратно в исходное состояние
  revert() {
    if (this.splitText) {
      this.splitText.revert();
      this.splitText = null;
    }
  }
}
